
import {defineComponent, PropType} from 'vue';
import MovieGridItem from "@/components/MovieGridItem.vue";
import iMovie from "@/interfaces/iMovie";


export default defineComponent({
  name: "MoviesGrid",
  components: {MovieGridItem},
  emits: ['onOpenModal'],
  props: {
    sectionTitle: {
      type: String,
      required: true,
      default: ''
    },
    movies: {
      type: Object as PropType<iMovie>,
      required: false
    }
  },
  setup(props, {emit}) {
    const openModal = (movieId: number): void => {
      emit('onOpenModal', movieId);
    }
    return {
      openModal
    }
  }
})
